import { render } from "./SpriteModal.vue?vue&type=template&id=4bc14ba2&scoped=true"
import script from "./SpriteModal.vue?vue&type=script&lang=js"
export * from "./SpriteModal.vue?vue&type=script&lang=js"

import "./SpriteModal.vue?vue&type=style&index=0&id=4bc14ba2&scoped=true&lang=css"

import exportComponent from "/Users/permartinson/Documents/GitHub/wpcedit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc14ba2"]])

export default __exports__